import React, { useMemo } from 'react';
import { channelInfo } from '@op/components/ChannelLabel';
import TableCommonHook from '@op/components/TableCommonHook';
import useLanguage from '@op/hooks/useLanguage';
import { dealWithOthersName } from '@op/utils/languageValue';
import { formatDateFunc } from '@op/utils/time';
import { reviewsFormat } from '@op/utils/value';
import { TABLE_HEADER_TYPE, TABLE_LABEL_NAME } from '../../constant';
import { NO_DATE } from '@op/constants';
import { getSpecialLabelName } from '../../utils';

interface IRealtimeChannelLanguage {
  header: string;
  title: string;
  formatValue?: (value: string | number) => string | number;
  data: any;
  filter: any;
  maxHeight?: number;
}
export default function Table(props: IRealtimeChannelLanguage) {
  const { title, header, formatValue = reviewsFormat, filter, data, maxHeight = 315.5 } = props;
  const { formatMessage } = useLanguage();

  const formatTableHeader = (cvm: any, header: string) => {
    if (header === 'Channel') {
      const { img, name } = channelInfo(cvm.key);
      return (
        <div className="channel-language-div">
          <img src={img} />
          <span className="channel-language-span">
            {name}
          </span>
        </div>
      );
    }
    if (header === 'Language') {
      return dealWithOthersName(cvm.key, 'language');
    }

    const label = getSpecialLabelName(cvm.key);
    return formatMessage({ id: label || NO_DATE.EMPTY });
  };
  const columns = useMemo(() => {
    return [
      {
        header: formatMessage({ id: 'Date' }),
        key: 'time',
        align: 'left',
        fixed: 'left',
        render: ({ time }: any) => {
          return formatDateFunc(filter?.date_type || 'hourly')?.(time) || time;
        },
      },
      {
        header: formatMessage({ id: header }),
        key: 'key',
        align: 'left',
        render: (cvm: any) => {
          return formatTableHeader(cvm, header);
        },
      },
      {
        header: formatMessage({ id: title }),
        key: 'value',
        align: 'right',
        render: (cvm: any) => formatValue(cvm?.value || 0),
      }
    ];
  }, [title, header]);

  return (
    <TableCommonHook
      recordKey={['time', 'name']}
      columns={columns}
      records={data}
      hasPageable={false}
      maxHeight={maxHeight}
      bordered
      minWidth={'auto'}
    />
  );
}